import { Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function PausedPollingState(props) {
    const { label, message, buttonLabel, onResume } = props;
    return (<EmptyState withAvatar icon={<Falcon icon="circle-pause"/>} title={label} description={message} actions={<Button onClick={onResume}>{buttonLabel}</Button>}/>);
}
